import { render, staticRenderFns } from "./toc-lesson.vue?vue&type=template&id=560385a9"
import script from "./toc-lesson.vue?vue&type=script&lang=js"
export * from "./toc-lesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports